import React from 'react';
import classnames from 'classnames';

export interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  is?: any;
  id: string;
}

export default class Input extends React.PureComponent<Props> {
  static defaultProps = {
    is: 'input'
  };

  input = React.createRef<HTMLInputElement>();

  componentDidMount() {
    if (this.props.autoFocus) setTimeout(() => this.input.current && this.input.current.focus(), 100);
  }

  render() {
    const { is, className, ...rest } = this.props;

    const Component = is;

    return <Component className={classnames('bg-transparent', className)} {...rest} ref={this.input} />;
  }
}
